export const environment = {
    production: false,
    back_api: 'https://test-back.toggolac.com/api',
    storage_api: 'https://teststorage.toggolac.com/api/storage/',
    enviame_api: "https://api.enviame.io/api/v1",
    key_enviame:"c424613ef20bf5e6b381de94c592a213"
};
